import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Keyboard } from "lucide-react";

/**
 * Overlay that lists the desktop keyboard shortcuts.
 *
 * Opened by pressing "?" anywhere except inputs; closed by Esc or
 * clicking the backdrop (both handled by the Dialog primitive).
 */
const SHORTCUTS = [
  { keys: ["1", "…", "9"], desc: "+1 the Nth link in the list" },
  { keys: ["⇧", "1", "…", "9"], desc: "−1 the Nth link (undo)" },
  { keys: ["?"], desc: "Toggle this overlay" },
  { keys: ["Esc"], desc: "Close overlays / cancel" },
];

export default function ShortcutsOverlay({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="shortcuts-overlay"
        className="max-w-[92vw] border-white/10 bg-[#0a0a0c] text-text-main sm:max-w-md"
      >
        <div className="mb-2 flex items-center gap-2">
          <span
            aria-hidden
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-accent/40 bg-accent/15 text-accent"
          >
            <Keyboard className="h-4 w-4" />
          </span>
          <div className="flex flex-col leading-tight">
            <DialogTitle className="font-display text-lg font-bold tracking-tight">
              Shortcuts
            </DialogTitle>
            <DialogDescription className="font-mono-safe text-[11px] text-text-muted">
              Keyboard commands (desktop)
            </DialogDescription>
          </div>
        </div>

        <ul
          className="mt-2 flex flex-col gap-2"
          data-testid="shortcuts-list"
        >
          {SHORTCUTS.map((s, i) => (
            <li
              key={i}
              className="flex items-center justify-between gap-3 rounded-lg border border-white/5 bg-white/[0.02] px-3 py-2.5"
            >
              <span className="text-sm text-text-main">{s.desc}</span>
              <span className="flex items-center gap-1">
                {s.keys.map((k, j) => (
                  <kbd
                    key={j}
                    className="inline-flex min-h-6 min-w-6 items-center justify-center rounded-md border border-white/15 bg-black/40 px-1.5 font-mono-num text-[11px] text-text-main shadow-sm"
                  >
                    {k}
                  </kbd>
                ))}
              </span>
            </li>
          ))}
        </ul>

        <p className="mt-2 font-mono-safe text-[11px] text-text-muted/70">
          Shortcuts are ignored while typing in an input or modal.
        </p>
      </DialogContent>
    </Dialog>
  );
}
